module.exports = __webpack_public_path__ + "img/2.8cb46e88.jpg";